"use strict";
/**
 * Test Authentication Helper Utilities
 *
 * Provides tools for simulating authentication in test/development environments.
 * SECURITY: NEVER enable in production builds.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.setupDefaultTestUser = exports.isTestModeEnabled = exports.getTestAuth = exports.clearTestAuth = exports.setTestAuth = exports.generateTestUserAuth = void 0;
const local_storage_names_1 = require("../constants/local_storage_names");
/**
 * Generate test authentication data for a user
 * @param userId - User ID
 * @param email - User email
 * @param name - User first name
 * @param surname - User last name
 * @param realToken - Optional real JWT token (if available)
 * @returns Test auth object with token and user data
 */
const generateTestUserAuth = (userId, email, name = "Test", surname = "User", realToken) => {
    return {
        token: realToken || `test_token_${userId}_${Date.now()}`,
        user: {
            _id: userId,
            email: email,
            name: name,
            surname: surname,
            signature: "",
            initials: "",
        },
    };
};
exports.generateTestUserAuth = generateTestUserAuth;
/**
 * Set test authentication in localStorage
 * Simulates a logged-in user session
 * @param userId - User ID
 * @param email - User email
 * @param name - User first name
 * @param surname - User last name
 * @param realToken - Optional real JWT token (if available, bypasses backend auth)
 */
const setTestAuth = (userId, email, name, surname, realToken) => {
    const testAuth = (0, exports.generateTestUserAuth)(userId, email, name, surname, realToken);
    localStorage.setItem(local_storage_names_1.USER_LOCAL_STORAGE, JSON.stringify(testAuth));
    console.log("✅ Test auth set for:", email);
    console.log("User ID:", userId);
    console.log("Token:", testAuth.token);
    console.log("Token type:", realToken ? "Real JWT (backend will accept)" : "Fake (frontend only)");
};
exports.setTestAuth = setTestAuth;
/**
 * Clear test authentication from localStorage
 */
const clearTestAuth = () => {
    localStorage.removeItem(local_storage_names_1.USER_LOCAL_STORAGE);
    console.log("🗑️ Test auth cleared");
};
exports.clearTestAuth = clearTestAuth;
/**
 * Get current test authentication from localStorage
 * @returns Test auth data or null if not set
 */
const getTestAuth = () => {
    const authStr = localStorage.getItem(local_storage_names_1.USER_LOCAL_STORAGE);
    if (!authStr) {
        return null;
    }
    try {
        return JSON.parse(authStr);
    }
    catch (error) {
        console.error("Failed to parse test auth:", error);
        return null;
    }
};
exports.getTestAuth = getTestAuth;
/**
 * Check if test mode is enabled
 * @returns true if ENABLE_TEST_AUTH is set to 'true'
 */
const isTestModeEnabled = () => {
    return process.env.ENABLE_TEST_AUTH === "true";
};
exports.isTestModeEnabled = isTestModeEnabled;
/**
 * Quick setup for testing with a default test user
 * Run this in browser console: window.setupTestUser()
 */
const setupDefaultTestUser = () => {
    const defaultUser = {
        userId: "test_user_123",
        email: "test@skysign.com",
        name: "Test",
        surname: "User",
    };
    (0, exports.setTestAuth)(defaultUser.userId, defaultUser.email, defaultUser.name, defaultUser.surname);
    console.log("🧪 Default test user setup complete!");
    console.log("You can now access documents as:", defaultUser.email);
    console.log("Refresh the page to activate.");
};
exports.setupDefaultTestUser = setupDefaultTestUser;
// Expose helper to window object for easy console access
if (typeof window !== "undefined") {
    window.setupTestUser = exports.setupDefaultTestUser;
    window.setTestAuth = exports.setTestAuth;
    window.clearTestAuth = exports.clearTestAuth;
    window.getTestAuth = exports.getTestAuth;
}
